import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import apiClient from "../../../components/utils/apiClient";
import TransactionCard from "../../../components/workers/TransactionCard";

const SingleTabTransactions = ({workerId,setIsActionLoading}) => {
    const { t } = useTranslation();
    const [transactions, setTransactions] = useState(null);

    const getTransactions = async () => {
        try {
          const response = await apiClient.get(`/transactions?workerId=${workerId}`);
          if(response?.data) {
            setTransactions(response?.data);
          } else {

          }
          setIsActionLoading(false);
        } catch(err) {setIsActionLoading(false);}
    }

    useEffect(()=>{
        setIsActionLoading(true);
        getTransactions();
    },[])


    return (
        <> {transactions && (transactions?.length > 0 ? <div className="flex flex-wrap gap-[16px] mt-[24px]"> {transactions?.map((transaction,index)=>{
            return (<TransactionCard key={`transaction-${index}`} transaction={transaction} />)
        })}</div> : <div className="border-[1px] border-grey-200 rounded-[16px] px-[20px] py-[30px] my-[24px] bg-white text-center mt-[50px] max-w-[800px] mx-auto">{t("noTransactionsFound")}</div>)}
        </>
    )
}

export default SingleTabTransactions;